import { useVariant } from "../../context/VariantContext";
import { CREDENTIALS } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Credentials = () => {
  const { variant } = useVariant();
  return (
    <section
      id="credentials"
      data-testid="credentials"
      className="relative border-t px-6 py-28 lg:px-10 lg:py-36"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionEyebrow index="06">Credentials</SectionEyebrow>
          <h2 className="font-head mt-6 max-w-2xl text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
            Accredited, compliant, and independently accountable.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px border sm:grid-cols-2 lg:grid-cols-4"
          style={{ borderColor: "var(--border)", background: "var(--border)" }}>
          {CREDENTIALS.map((c, i) => (
            <Reveal key={c.title} delay={(i % 4) * 0.06}>
              <div
                className="flex h-full flex-col px-6 py-8"
                style={{ background: "var(--bg)" }}
              >
                <h3
                  className={`font-head text-xl text-[color:var(--text)] ${
                    variant === "swiss" ? "font-bold tracking-tight" : ""
                  }`}
                >
                  {c.title}
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-[color:var(--text-2)]">
                  {c.org}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
